import { render, staticRenderFns } from "./CommunicationType.vue?vue&type=template&id=aeae1146"
import script from "./CommunicationType.vue?vue&type=script&lang=js"
export * from "./CommunicationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports